var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAnuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 610 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #171c66;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.8,351.6h258.1c97.1,0,175.8-78.7,175.8-175.8S531,0,433.9,0H175.8C78.7,0,0,78.7,0,175.8s78.7,175.8,175.8,175.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20492",
    className: "cls-1",
    d: "M405.1,149.5h0c3.7,0,7.4,1,10.6,2.9h.1c.7.5,1.3.9,1.9,1.4h0c2.2,1.6,5.3,1.1,6.9-1.2,1.5-2.1,1.1-5.1-.9-6.7-5.3-4.1-11.9-6.3-18.7-6.3h0c-17,0-30.8,13.8-30.8,30.8s13.8,30.8,30.8,30.8h0c6.7,0,13.3-2.2,18.7-6.4h.2c2.1-1.9,2.5-5,.8-7.1-1.7-2.1-4.8-2.5-6.9-.8-.6.5-1.3.9-1.9,1.3h-.1c-3.2,2-6.9,3-10.6,3h-.5c-11.5-.1-20.8-9.6-20.7-21.1.1-11.5,9.6-20.8,21.1-20.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20493",
    className: "cls-1",
    d: "M475.6,147.9c-12.4-11.6-31.9-10.9-43.5,1.5-11.6,12.4-10.9,31.9,1.5,43.5,11.8,11.1,30.2,11.1,42.1,0,12.4,11.6,31.9,10.9,43.5-1.5,11.6-12.4,10.9-31.9-1.5-43.5-11.8-11.1-30.2-11.1-42.1,0M511.6,184.9c-8,8.3-21.3,8.4-29.6.4-3.1-3-5.2-6.9-6-11.2-.5-2.7-3.1-4.5-5.8-4-2.7.5-4.5,3.1-4,5.8.6,3.2,1.6,6.2,3.2,9.1-8,8.3-21.3,8.4-29.6.3s-8.4-21.3-.3-29.6c5.1-5.2,12.5-7.4,19.7-5.8h0c7.5,1.7,13.5,7.5,15.5,15,.6,2.7,3.3,4.3,5.9,3.7s4.3-3.3,3.7-5.9c0,0,0-.1,0-.2h0c-.6-2.4-1.5-4.7-2.7-6.8,8-8.3,21.3-8.4,29.6-.4,8.3,8,8.4,21.3.4,29.6h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20494",
    className: "cls-1",
    d: "M546.1,139.6c-6.8,0-13.3,2.2-18.7,6.3-2.2,1.6-2.6,4.8-1,6.9,1.6,2.2,4.8,2.6,6.9,1h0c9.2-7,22.3-5.2,29.2,4,6.9,9.2,5.1,22.3-4.1,29.2-3.6,2.7-8,4.2-12.4,4.2-3.1-.2-6.1-1.2-8.8-2.8v-1.8c0-2.7-2.2-5-4.9-5s-4.8,2.1-5,4.8v33.3c0,2.7,2.4,4.9,5.1,4.8,2.6,0,4.8-2.2,4.8-4.8h0v-20.3c2.8,1.1,5.7,1.7,8.8,1.8,17,0,30.8-13.8,30.8-30.8h0c0-17.1-13.8-30.8-30.8-30.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20495",
    className: "cls-1",
    d: "M77.5,183.2v-23.8c.1-13-10.6-17.6-21.9-17.6-6.5,0-12.8,1.4-18.6,4.3l1.2,4.3c5.2-2.7,10.9-4.1,16.8-4,8.3,0,17.6,2.6,17.6,12.8v8c-6-3-12.6-4.6-19.4-4.5-10.5,0-20.3,5.7-20.3,17.6s9.4,15.8,18.5,15.8,17.9-2.7,22-10.3c-.3,8.3,1.9,11.4,10.8,10l-.2-3.6c-6.9.9-6.6-2.7-6.6-9M72.6,178.8c-2.3,9-11.8,12.8-20.3,12.8s-14-3.6-14.3-11.6c-.3-8.7,8-13,15.8-13s13,1.6,18.7,4.8v7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20496",
    className: "cls-1",
    d: "M114.9,141.8c-7.7-.6-15.1,3-19.3,9.4,0-8.3-3.7-9.6-11.6-8.5v4.5c5.9-.9,6.7.9,6.7,9.2v38.6h5.2v-30.9c-.5-9.3,6.6-17.2,15.9-17.6h1.9c8.7-.6,16.3,5.9,17,14.7,0,.7,0,1.4,0,2.1v31.7h5.2v-31.7c0-12.5-7.8-21.7-21-21.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20497",
    className: "cls-1",
    d: "M190,181.9v-38.9h-5.2v30.9c0,10.8-6.2,17.8-16.6,17.6-8.7.6-16.3-5.9-17-14.7,0-.7,0-1.4,0-2.1v-31.7h-5.2v31.7c0,12.5,7.8,21.7,21,21.7,7.4.7,14.6-3,18.3-9.4,0,8.3,3.5,9.6,11.4,8.5v-4.3c-5.9.9-6.7-.9-6.7-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20498",
    className: "cls-1",
    d: "M231.2,120.4v-.4l-4.3-2.1-8.8,13.3v.3h4.5s8.5-11.2,8.5-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20499",
    className: "cls-1",
    d: "M242.9,183.2v-23.8c.1-13-10.6-17.6-21.9-17.6-6.5,0-12.8,1.4-18.6,4.3l1.2,4.3c5.2-2.7,10.9-4.1,16.8-4,8.3,0,17.6,2.6,17.6,12.8v8c-6-3-12.6-4.6-19.4-4.5-10.5,0-20.3,5.7-20.3,17.6s9.4,15.8,18.5,15.8,17.9-2.7,22-10.3c-.3,8.3,1.9,11.4,10.8,10l-.2-3.6c-6.9.9-6.6-2.7-6.6-9M238.1,178.8c-2.3,9-11.8,12.8-20.3,12.8s-14-3.6-14.3-11.6c-.3-8.7,8-13,15.8-13s13,1.6,18.7,4.8v7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20500",
    className: "cls-1",
    d: "M261.6,149.9c0-6.1-3.6-8.3-11.9-6.8l.2,4.5c6.6-.9,6.7,2.4,6.7,7.5v40.2h5.2v-33.8c.1-8.1,6.8-14.5,14.9-14.4h.4c3.6,0,7.2.8,10.4,2.6v-5.5c-3.1-1.4-6.5-2.1-9.9-2.2-6.4-.7-12.6,2.4-15.9,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20501",
    className: "cls-1",
    d: "M288.9,150.6l1.9-4.5c-1.1-.8-2.2-1.4-3.4-1.9v5.5c.5.3,1.1.6,1.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20502",
    className: "cls-1",
    d: "M298.8,121.7c-1.9-.1-3.5,1.3-3.6,3.1v.5c0,1.9,1.4,3.5,3.3,3.6h.4c1.9,0,3.3-1.6,3.2-3.4h0c0-2-1.4-3.6-3.3-3.7h0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2345",
    className: "cls-1",
    x: 296.2,
    y: 143.3,
    width: 4.9,
    height: 50.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20503",
    className: "cls-1",
    d: "M309.6,169c0,35.4,53.3,35.9,54.7,1.4v-2.8c-1.4-34.6-54.7-34.1-54.7,1.4M314.8,169c0-29.8,44.4-29.8,44.4,0s-44.4,29.6-44.4,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.7,250.6v4.1h-21.5v-1.2l13.9-16.5c1.7-2,2.4-3.9,2.4-5.9,0-3.1-2-5.1-5.6-5.1s-6,2.1-6,6.6h-4.2c0-6.9,4.3-10.5,10.1-10.5s10.1,3.5,10.1,8.7-1.1,5.4-3.5,8.4l-9.7,11.4h13.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.4,243.5v-10c0-6.9,4.8-11.4,12-11.4s12,4.5,12,11.4v10c0,7-4.8,11.6-12,11.6s-12-4.5-12-11.6ZM420.8,243.4v-9.9c0-4.7-2.8-7.5-7.4-7.5s-7.4,2.8-7.4,7.5v9.9c0,4.9,2.8,7.7,7.4,7.7s7.4-2.8,7.4-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.1,250.6v4.1h-21.5v-1.2l13.9-16.5c1.7-2,2.4-3.9,2.4-5.9,0-3.1-2-5.1-5.6-5.1s-6,2.1-6,6.6h-4.2c0-6.9,4.3-10.5,10.1-10.5s10.1,3.5,10.1,8.7-1.1,5.4-3.5,8.4l-9.7,11.4h13.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480,248h-3.7v6.8h-4.4v-6.8h-16.3v-2.1l15.9-23.3h4.8v21.8h3.7s0,3.7,0,3.7ZM469.1,232.9l-7.7,11.4h10.8v-15.9l-3,4.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnuario);
export default __webpack_public_path__ + "static/media/logo-anuario.9749f0ebd08cd98d3cf046cd8d0a8680.svg";
export { ForwardRef as ReactComponent };